import { Component, Inject, OnInit } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { CampoAdicionalService } from '../../campo-adicional.service';

@Component({
  selector: 'app-campo-adicional-list',
  templateUrl: './campo-adicional-list.component.html',
  styleUrls: ['./campo-adicional-list.component.scss']
})
export class CampoAdicionalListComponent implements OnInit {
  campoAdicionalList : Array<any> = [];

  constructor( @Inject(MAT_DIALOG_DATA) public data, private dialogRef: MatDialogRef<CampoAdicionalListComponent> ) { }

  ngOnInit() { }

  

  listChange( e : any ) {
    const { value : { descripcion, titulo, campo_adicional_id, documento_id } } = e.option;
    let result = null;
    (campo_adicional_id) ? result = { descripcion, titulo, campo_adicional_id } : result = { descripcion, documento_id }
    this.dialogRef.close({ ...result });
  }

}
